// extracted by mini-css-extract-plugin
export default {"form":"styles_form__kIY0q","container":"styles_container__-zesH","input":"styles_input__eYllI","image":"styles_image__lmvWz","headerContainer":"styles_headerContainer__Uj7sZ"};